import React from 'react';
import { useNavigate } from 'react-router-dom';
import Badge from '../../components/Badge';

export default ({ locations }) => {
	const navigate = useNavigate();
	return (
		<div className="overflow-auto bg-white shadow sm:rounded-md">
			<ul role="list" className="divide-y divide-gray-200">
				{locations?.map((location) => {
					const locationBadge = {
						operational: { label: '', value: 'success' },
						maintenance: {
							label: 'Maintance',
							value: 'info',
						},
						disruption: {
							label: 'Location Disruption',
							value: 'caution',
						},
						partialDisruption: {
							label: 'Partial System Distruption',
							value: 'caution',
						},
						completeDisruption: {
							label: 'Complete System Distruption',
							value: 'warning',
						},
						locationDisruption: {
							label: 'Location Disruption',
							value: 'warning',
						},
						locationOutage: { label: 'Location Outage', value: 'error' },
						partialOutage: { label: 'Partial System Outage', value: 'warning' },
						completeOutage: { label: 'Complete System Outage', value: 'error' },
						offline: {
							label: 'Not in service',
							value: 'default',
						},
					}[location.health];

					return (
						<li key={location?.name}>
							<div
								className="block hover:bg-gray-50 cursor-pointer"
								onClick={() => navigate(`/assets/location/${location?.id}`)}
							>
								<div className="px-4 py-4 sm:px-6">
									<div className="flex items-center justify-between">
										<div className="flex items-center flex-1 justify-between">
											<p className="truncate text-sm font-medium text-gray-600">
												{location?.name}
											</p>
											{location.health ? (
												<Badge isBeta status={locationBadge?.value} size="xxs">
													{locationBadge?.label}
												</Badge>
											) : null}
										</div>
									</div>
								</div>
							</div>
						</li>
					);
				})}
			</ul>
		</div>
	);
};
